import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const ScrollButton = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const [atBottom, setAtBottom] = useState(false);
useEffect(() => {
  const checkScroll = () => {
    const isPageScrollable = document.body.offsetHeight > window.innerHeight;
    const scrolledToBottom =
      isPageScrollable &&
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 50;

    setAtBottom(scrolledToBottom);
  };

  // فحص أول ما يتغير المسار
  checkScroll();

  window.addEventListener("scroll", checkScroll);
  return () => window.removeEventListener("scroll", checkScroll);
}, [location.pathname]);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={atBottom ? scrollToTop : scrollToBottom}
      className={`fixed bottom-6 ${
        i18n.language === "ar" ? "left-6" : "right-6"
      } p-4 bg-primary text-white rounded-full shadow-lg hover:bg-[#005512] transition-all`}
    >
      {atBottom ? <FaArrowUp size={20} /> : <FaArrowDown size={20} />}
    </button>
  );
};

export default ScrollButton;
